'use strict';

var $ = require('jquery');
var _ = require('underscore');
var utils = require('./utils');
var ajax = require('./xhr').instance;

var root = require('./root').window;
var windowIsUnloading = false;
var queuedLogs = [];
var onBeforeUnloadHandlers = $.Callbacks('once'); // TODO: remove this dependency on jQuery

// All logs are queued before actually sending, in order to make the requests in the
// appropriate async/sync manner.
function processLogs() {
  var log;
  while (log = queuedLogs.shift()) {
    log();
  }
}

/// <summary>
/// A client-side logger, made to simplify logging and keep consistency.
/// Intended future improvements: support batching/reducing (e.g. logging counts of an event as a single),
/// storing unsent logs in local storage (on page unload, etc.)
/// </summary>
function Logger(logName, xhr) {
  this._name = logName;
  ajax = xhr || ajax;
}

_.extend(Logger.prototype, {
  log: function(message, data) {
    var name = this._name;

    // queue up the log as a function
    queuedLogs.push(function() {
      // handle the case conversion here (for now at least) because it's much easier than on the server
      ajax.post('/Logging/LogData', { loggerName: name, message: message, data: utils.copyObjectToPascalCase(data) }, { async: !windowIsUnloading });
    });

    // defer so that we can catch logs that occur immediately before page navigation
    _.defer(function() {
      _.defer(processLogs);
    });
  },
});

_.extend(Logger, {
  onBeforeUnload: onBeforeUnloadHandlers.add,
});

// We want to catch window unload (and beforeunload, to be thorough) events and make sure
// that any queued logs are sent synchronously (to prevent getting canceled by the browser).
$(function() {
  $(root).on('beforeunload unload', function() {
    windowIsUnloading = true;

    onBeforeUnloadHandlers.fire();

    processLogs();
  });
});

module.exports = Logger;
